import { IconCaret } from "src/components/icons-mui/caret";

export const TablePaginationDropdownIcon = () => (
    <IconCaret
        sx={{
            width: "16px",
            height: "16px",
            position: "absolute",
            right: 0,
            pointerEvents: "none",
            userSelect: "none",
        }}
    />
);
